






import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import logger from "@/configs/logger";

@Component
export default class BufferStatus extends Vue {
  @Prop() attributes!: any;

  timer: number | undefined = undefined;
  bufferTimeLeft = -1;

  @Watch("attributes")
  onattributesUpdate(val: any) {
    if (val.call_ended) {
      window.clearInterval(this.timer);
    }
  }

  mounted() {
    this.timer = setInterval(() => {
      const { created_ts, buffer_time_s, call_ended } = this.attributes;
      if (buffer_time_s && !call_ended) {
        const passedTime = Math.floor(moment().unix() - created_ts.seconds);
        this.bufferTimeLeft =
          buffer_time_s > passedTime ? buffer_time_s - passedTime : 0;
      }
    }, 500);
  }

  beforeDestroy() {
    window.clearInterval(this.timer);
  }

  get buffer(): number | null {
    if (!Object.keys(this.attributes).length) return null;
    if (!this.attributes.buffer_time_s) return null;
    if (this.bufferTimeLeft === -1) return null;
    return !this.bufferTimeLeft ? null : this.bufferTimeLeft;
  }
}
